import React, { useEffect } from 'react';
import bem from 'utils/bem';
import { useFormikContext } from 'formik';
import Text from 'components/Text';
import { Button } from 'components/Button';
import EmailField from 'forms/fields/EmailField';
import UserAgreementCheckboxField from 'forms/fields/UserAgreementCheckboxField';
import PaymentField from 'forms/fields/PaymentField';
import Icon from 'components/Icon';
import PaymentBalanceField from "forms/fields/PaymentBalanceField";
import UserFields from 'forms/forms/CertificateForm/UserFields';
import FormikCheckboxField from 'forms/fields/CheckboxField/FormikCheckboxField';
import './index.sass'
import Summary from './Summary';
import { ForeignCardWidget } from 'components/ForeignCardWidget';

const { block, el } = bem('certificate-form');

export default ({ price, ...form }) => {

    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        setFieldValue('price', price);
    }, [ price ])

    const gift = form.values.gift;

    const preventCopyPasting = (e) => {
        e.preventDefault();
        return false
    }

    return <form className={ block() } onSubmit={ form.handleSubmit }>
        <div className={ el('title') }>
            <Text serif>Покупка сертификата</Text>
        </div>
        <div className={ el('fields')}>
            <div className={ el('user-fields') }>
                <UserFields/>
            </div>
            <div className={ el('gift') }>
                <FormikCheckboxField className={ el('checkbox-gift') } name='gift' text={ 'Сертификат в подарок' }
                                     comment={ `Если Вы хотите подарить сертификат с обращением к покупателю от otvet.co,
                                      otvet.co направит сертификат и кодовое слово для активации суммы на почту
                                      получателя подарочного сертификата` }
                />
                { !!gift && <>
                    <div className={ el('gift-fields') }>
                        <div className={ el('mail') }>
                            <EmailField
                                onPaste={ preventCopyPasting }
                                placeholder={ 'Email получателя сертификата' }
                                name="mail"
                            />
                        </div>
                        <div className={ el('mailConfirmation') }>
                            <EmailField
                                placeholder={ 'Повторите Email' }
                                onPaste={ preventCopyPasting }
                                name="mailConfirmation"
                            />
                        </div>
                    </div>
                    <div className={ el('details') }>
                        <Icon name={ 'info' }/>
                        <Text>Письмо с подтверждением оплаты и электронный чек будут направлены на почту, указанную в графе
                            “Ваш
                            E-mail”</Text>
                    </div>
                </> }
            </div>
            <div className={ el('payment') }>
                <div className={ el('payment-title') }>
                    <Text>Способы оплаты</Text>
                </div>
                <PaymentField/>
            </div>
            {/*<div className={ el('payment-balance') }>*/}
            {/*    <PaymentBalanceField className={ el('balance') } price={ price } mod={ 'long' }/>*/}
            {/*</div>*/}
            {/*<div className={ el('details') }>*/}
            {/*    <Icon name={ 'info' }/>*/}
            {/*    <Text>В течение 30 минут после оплаты доступ к курсу появится в личном кабинете в разделе "Курсы".</Text>*/}
            {/*</div>*/}
            { window.isRuDomain && <ForeignCardWidget /> }
            <div className={ el('summary') }>
                <Summary price={price} />
            </div>
            <div className={ el('footer') }>
                <UserAgreementCheckboxField name='acceptConditions'/>
                <Button
                    type={ 'submit' }
                    mod='gold'
                    disabled={ form.isSubmitting }>
                    Оплатить
                </Button>
            </div>
        </div>
    </form>
}
